import React, { useRef, useCallback } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import Button from '../../../common/inputs/Button';
import Section from '../../../layout/Section';
import YieldForecastTable from '../../../tables/YieldForecastTable';
import { EditableTableRef } from '../../../tables/common/EditableTable';
import { Ertragsprognose } from '../../../../types';

interface YieldForecastsSectionProps {
    allYieldForecasts: Ertragsprognose[];
    canEdit: boolean;
    /** Prognose wurde erstellt – Backend-Response direkt einsetzen */
    onForecastCreated?: (forecast: Ertragsprognose) => void;
    /** Prognose wurde aktualisiert – Backend-Response direkt einsetzen */
    onForecastUpdated?: (forecast: Ertragsprognose) => void;
    /** Prognose wurde gelöscht – lokal aus Array entfernen */
    onForecastDeleted?: (forecastId: string) => void;
    /** DeductionItem geändert – einzelne Prognose nachladen */
    onDeductionChanged?: (forecastId: string) => void;
}

/**
 * Ertragsprognosen-Section mit Inline-Editing
 * Verwendet EditableTable für direkte Bearbeitung in der Tabelle
 * Abzüge werden in expandierbaren Zeilen direkt unter der jeweiligen Prognose angezeigt
 */
const YieldForecastsSection: React.FC<YieldForecastsSectionProps> = ({
    allYieldForecasts,
    canEdit,
    onForecastCreated,
    onForecastUpdated,
    onForecastDeleted,
    onDeductionChanged,
}) => {
    // Ref zur Tabelle für startCreating-Aufruf
    const tableRef = useRef<EditableTableRef>(null);

    const handleNewForecast = useCallback(() => {
        tableRef.current?.startCreating({
            name: '',
        });
    }, []);

    // Konvertiere Yield Forecasts zu Format für die Tabelle
    const safeYieldForecasts = Array.isArray(allYieldForecasts) ? allYieldForecasts : [];

    // Mappe die Daten für die Tabelle
    const gutachtenListe = safeYieldForecasts.map(ep => ({
        ...ep,
        abzuege_gesamt: ep.abzuege_gesamt,
    }));

    return (
        <Section
            title="Ertragsprognosen"
            noPadding={true}
            actions={
                canEdit ? (
                    <Button
                        variant="primary"
                        startIcon={<AddIcon />}
                        onClick={handleNewForecast}
                    >
                        Neue Prognose
                    </Button>
                ) : undefined
            }
        >
            <YieldForecastTable
                ref={tableRef}
                gutachten={gutachtenListe}
                canEdit={canEdit}
                onForecastCreated={onForecastCreated}
                onForecastUpdated={onForecastUpdated}
                onForecastDeleted={onForecastDeleted}
                onDeductionChanged={onDeductionChanged}
            />
        </Section>
    );
};

export default YieldForecastsSection;

